import React from 'react';
import { Shield, Truck, ReceiptText } from 'lucide-react';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const features = [
    {
      icon: Shield,
      title: 'Seller Verification',
      description: 'Approved sellers display verification separately from real performance and verified buyer reviews.',
      color: 'blue'
    },
    {
      icon: Truck,
      title: 'Flexible Fulfillment',
      description: 'Each seller confirms delivery or pickup costs and expected dates before the buyer submits payment.',
      color: 'green'
    },
    {
      icon: ReceiptText,
      title: 'Transparent Pricing',
      description: 'Product prices, seller taxes and shipping are shown clearly before payment, without an Eulua sales commission.',
      color: 'orange'
    }
  ];

  return (
    <section className="features-section">
      <div className="features-container">
        <div className="features-header">
          <h2 className="features-title">
            Why shop on Eulua?
          </h2>
          <p className="features-description">
            Products for your business from verified suppliers with transparent purchasing terms
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className={`feature-icon-container ${feature.color}`}>
                <feature.icon className={`feature-icon ${feature.color}`} />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
